import gql from 'graphql-tag';

export const VODSET_CREATE_RAW = `
  mutation ($file: Upload!){
    vodsetCreate(set: $file) {
      id
      name
      status
      priority
    }
  }
`;

export const VODSET_CREATE = gql`${VODSET_CREATE_RAW}`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/vodsets/create.js